import { useTranslation } from 'react-i18next';
import type { InternalLinkSuggestion } from '@/services/copilot';
import styles from './InternalLinkPicker.module.css';

interface InternalLinkPickerProps {
  isOpen: boolean;
  onClose: () => void;
  suggestions: InternalLinkSuggestion[];
  isLoading: boolean;
  onApplyLink: (anchorText: string, targetUrl: string) => void;
}

export function InternalLinkPicker({
  isOpen,
  onClose,
  suggestions,
  isLoading,
  onApplyLink,
}: InternalLinkPickerProps) {
  const { t } = useTranslation(['common', 'nav', 'board', 'articles', 'analytics', 'feeddrive', 'config', 'strategist']);
  void t;
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>Auto-Links Internos Contextuais (Acervo 11.000+ Matérias)</h3>
          <button className={styles.closeBtn} onClick={onClose}>Fechar
          </button>
        </div>

        <div className={styles.modalSubheader}>
          <span className={styles.antiCannibalizationBadge}>
            ️ Trava Anti-Canibalização SEO Ativa (1 link/entidade · Máx 2 links/300w)
          </span>
        </div>

        <div className={styles.modalBody}>
          {isLoading ? (
            <div className={styles.loadingState}>Buscando conexões no acervo...</div>
          ) : suggestions.length === 0 ? (
            <div className={styles.emptyState}>Nenhuma sugestão de link interno encontrada para o texto atual.
            </div>
          ) : (
            <div className={styles.suggestionsList}>
              {suggestions.map((s, idx) => (
                <div key={idx} className={styles.suggestionCard}>
                  <div className={styles.cardHeader}>
                    <span className={styles.anchorBadge}>Âncoras: "{s.anchor_text}"</span>
                    <span className={styles.scoreBadge}>Relevância: {(s.relevance_score * 100).toFixed(0)}%</span>
                  </div>

                  <h4 className={styles.targetTitle}>{s.target_title}</h4>
                  <p className={styles.targetUrl}>{s.target_url}</p>
                  <p className={styles.contextSentence}>{s.context_sentence}</p>

                  <button
                    className={styles.applyBtn}
                    onClick={() => {
                      onApplyLink(s.anchor_text, s.target_url);
                      onClose();
                    }}
                  >
                    1-Clique: Inserir Link no Texto
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
